import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type addRowToMatrixElementButton_AddRowToMatrixElementMutation } from "@relay/addRowToMatrixElementButton_AddRowToMatrixElementMutation.graphql";
import { ADD_ROW_TO_MATRIX_ELEMENT_MUTATION } from "./add-row-to-matrix-element-button.graphql";
import { type AddRowToMatrixElementButtonProps } from "./add-row-to-matrix-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const AddRowToMatrixElementButton = ({
	matrixElementId,
}: AddRowToMatrixElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();

	const [addRowToMatrixElement] =
		useMutation<addRowToMatrixElementButton_AddRowToMatrixElementMutation>(
			ADD_ROW_TO_MATRIX_ELEMENT_MUTATION,
		);

	return (
		<Button
			type="button"
			className="m-2 flex flex-grow-1"
			label={t("educationalOffer.newRow")}
			onClick={() => {
				addRowToMatrixElement({
					variables: {
						input: {
							matrixElementId,
							rowTitle: t("educationalOffer.newRow"),
							correctAnswerContent: t("educationalOffer.correctAnswer"),
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
